namespace RedBullMOBILE360.Sms {

    @Serenity.Decorators.registerClass('RedBullMOBILE360.Sms.WhitelistMemberGrid')
    export class WhitelistMemberGrid extends Serenity.EntityGrid<WhitelistMemberRow, any> {
        protected getColumnsKey() { return WhitelistMemberColumns.columnsKey; }
        protected getDialogType() { return WhitelistMemberDialog; }
        protected getIdProperty() { return WhitelistMemberRow.idProperty; }
        protected getInsertPermission() { return WhitelistMemberRow.insertPermission; }
        protected getLocalTextPrefix() { return WhitelistMemberRow.localTextPrefix; }
        protected getService() { return WhitelistMemberService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
        }

        protected override getButtons(): Serenity.ToolButton[] {
            let buttons = super.getButtons();
            //buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            buttons.push(Serenity.Extensions.ExcelExportHelper.createToolButton({
                title: 'Export to Excel',
                grid: this,
                service: WhitelistMemberService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit()
            }));

            return buttons;
        }
    }
}